import { Values, Errors } from './types';
import { useFieldValidation } from './useServerValidation';

export const INVALID_EMAIL_FORMAT_ERROR = 'invalid format';

const useEmailValidation = (values: Values): [boolean, boolean, Errors] => {
  const [isEmailValidOnServer, isEmailValidating, emailErrors] = useFieldValidation(values, 'email');

  const isInFormat =
    /^([\w\-.+]+)@((([\w-]+\.)+))([a-zA-Z]{2,5})$/.test(values.email) &&
    values.email.length >= 6 &&
    values.email.length <= 50;
  const errors = emailErrors.email || [];

  if (!isInFormat) errors.push(INVALID_EMAIL_FORMAT_ERROR);

  return [isEmailValidOnServer && isInFormat, isEmailValidating, { email: errors }];
};

export default useEmailValidation;
